import React from 'react';
import { QUOTED, PRICE_SELECTED } from 'pu-data/QuoteSteps';
import { findSupplier } from 'pu-data/Utils';
import { useDispatch, useSelector } from 'react-redux';
import PriceMatrix from './PriceMatrix';

import { priceSelected } from '../../fabricationSlice';

const buildMatrices = (params) => {
  const { quote, supplierInfos, parametersChanged } = params;
  if (!quote || !quote.line_items) {
    return [];
  }

  return quote.line_items.map((li) => (
    <PriceMatrix
      key={li.product_key}
      lineItem={li}
      supplier={findSupplier(supplierInfos, li.product_key)}
      parametersChanged={parametersChanged}
      {...params} />
  ))
};

const PriceMatrices = () => {
  const dispatch = useDispatch();
  const {
    quote,
    parametersChanged,
    quoteStep,
    parameters,
  } = useSelector((state) => state.fabrication)

  const onPriceSelect = (data) => dispatch(priceSelected(data));

  const isVisible = [QUOTED, PRICE_SELECTED].indexOf(quoteStep) >= 0;
  if (!isVisible) {
    return null;
  }

  return (
    <div className="pcb-price-section">
      <div className="price-matrices">
        <div id="error_price_matrix" />
        {buildMatrices({
          quote,
          quoteStep,
          supplierInfos: Spree.supplier_infos,
          parametersChanged,
          parameters,
          onPriceSelect,
        })}
      </div>
    </div>
  )
};

export default PriceMatrices;
